import React, { useEffect, useState } from "react";
import { useLoaderData } from "react-router-dom";
import MUITable from "Components/UI/Tables/MUITable";
import { Link } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import LinkIcon from "@mui/icons-material/Link";
import { getUsers } from "API/swesum";
import { useClients } from "Context/Clients";

const createTableRows = (user) => {
  return user.map((u) => {
    return [u.Id, u.Username, u.Usertype, u.UsertypeId];
  });
};

export default function UserTable() {
  const [rows, setRows] = useState([]);
  const [users, setUsers] = useState([]);
  const { clients, fetchClients } = useClients();

  useEffect(() => {
    const asyncFetchUsers = async () => {
      await fetchClients();
      const users = await getUsers();
      setUsers(users);
      //setRows(createTableRows(users));
    };
    asyncFetchUsers();
  }, [clients, fetchClients]);

  useEffect(() => {
    setRows(createTableRows(users, clients));
  }, [clients, users]);

  const columns = [
    {
      name: "",
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRenderLite: (dataIndex) => {
          return (
            <IconButton
              component={Link}
              to={`${rows[dataIndex][0]}`}
              aria-label="edit"
              size="small"
            >
              <LinkIcon sx={{ p: 0, m: 0 }} />
            </IconButton>
          );
        },
      },
    },
    {
      name: "ID",
      options: {
        filter: false,
      },
    },
    {
      name: "Epost",
      options: {
        filter: false,
      },
    },
    {
      name: "Roll",
    },
    {
      name: "Klient",
      options: {
        customBodyRender: (value) => {
          if (value && clients?.length > 0) {
            return (
              clients?.find((c1) => c1.Id === Number(value))?.Title ??
              "Ingen klient"
            );
          }
          return "";
        },
      },
    },
  ];

  const options = {
    selectableRowsHeader: false,
    selectableRowsHideCheckboxes: true,
    downloadOptions: {
      separator: ";",
      filename: "all_clients.csv",
    },
    rowsPerPage: 30,
    rowsPerPageOptions: [10, 30, 100],
    onDownload: (buildHead, buildBody, columns, data) => {
      return "\uFEFF" + buildHead(columns) + buildBody(data);
    },
  };

  return (
    <MUITable options={options} title={""} data={rows} columns={columns} />
  );
}
